module.exports = __webpack_public_path__ + "img/CZ.ed545b16.svg";